import React from "react";
import { Navigate } from "react-router-dom";

/**
 * RoleRoute — only renders children if the logged-in user's role
 * is in the `allowed` array. superadmin always passes.
 */
export default function RoleRoute({ allowed = [], children }) {
  let user = null;
  try {
    user = JSON.parse(localStorage.getItem("user") || "null");
  } catch {}

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // superadmin bypasses all role restrictions
  if (user.role === "superadmin") {
    return children;
  }

  if (!allowed.includes(user.role)) {
    return <Navigate to="/403" replace />;
  }

  return children;
}